// ─── IoTMATE Device Management – Dummy Data ────────────────────────────────

const now = new Date();
const ago = (min) => new Date(now - min * 60000).toLocaleString();

export const deviceDummyData = {

  // ── Gateways ───────────────────────────────────────────────────────────────
  gateways: [
    {
      id: "GW-001", name: "LoRa Gateway Alpha", role: "Gateway",
      type: "LoRa Gateway", connectivity: "LoRa",
      status: "Online", healthScore: 96,
      model: "LGW-5000", make: "RAK Wireless", firmware: "v2.4.1",
      serialNumber: "LGW-A1029-X", installedOn: "2024-03-12", lastSeen: ago(1),
      site: "Industrial Zone A", siteId: "SITE-001", assignedSolution: "STP",
      battery: null, signal: -68,
      childDeviceIds: ["SN-001", "SN-002", "SN-003", "CT-001"],
      loraDetails: { rssi: -68, snr: 8.5, sf: 10, bandwidth: "125kHz", codingRate: "4/5", packetsToday: 1248, packetLoss: 0.2 },
      ip: "192.168.1.10", mac: "AA:BB:CC:11:22:01",
      telemetry: null,
      events: [
        { time: ago(2), type: "Info", msg: "Heartbeat OK — all 4 child devices reporting" },
        { time: ago(60), type: "Info", msg: "Firmware auto-update check passed (v2.4.1 latest)" },
        { time: ago(480), type: "Warning", msg: "Channel congestion detected — switched to SF11" },
      ]
    },
    {
      id: "GW-002", name: "LoRa Gateway Beta", role: "Gateway",
      type: "LoRa Gateway", connectivity: "LoRa",
      status: "Warning", healthScore: 71,
      model: "LGW-3000", make: "RAK Wireless", firmware: "v2.3.0",
      serialNumber: "LGW-B2041-X", installedOn: "2024-05-20", lastSeen: ago(8),
      site: "Office Block B", siteId: "SITE-002", assignedSolution: "AQM",
      battery: null, signal: -82,
      childDeviceIds: ["SN-004", "SN-005"],
      loraDetails: { rssi: -82, snr: 3.1, sf: 11, bandwidth: "125kHz", codingRate: "4/5", packetsToday: 654, packetLoss: 6.8 },
      ip: "192.168.1.11", mac: "AA:BB:CC:11:22:02",
      telemetry: null,
      events: [
        { time: ago(8), type: "Warning", msg: "High packet loss (6.8%) — backhaul signal degraded" },
        { time: ago(240), type: "Info", msg: "SF auto-adjusted from 10 to 11" },
        { time: ago(1440), type: "Error", msg: "Backhaul disconnect for 3 min — recovered" },
      ]
    },
    {
      id: "GW-003", name: "WiFi Gateway Gamma", role: "Gateway",
      type: "WiFi Gateway", connectivity: "WiFi",
      status: "Online", healthScore: 88,
      model: "WGW-2000", make: "IoTMATE", firmware: "v3.1.2",
      serialNumber: "WGW-C3055-X", installedOn: "2024-07-08", lastSeen: ago(0),
      site: "Residential Complex C", siteId: "SITE-005", assignedSolution: "Facility",
      battery: null, signal: -55,
      childDeviceIds: ["SN-006", "SN-007", "SN-008"],
      wifiDetails: { rssi: -55, channel: 6, frequency: "2.4GHz", ssid: "IoTMATE-Infra", bssid: "DE:AD:BE:EF:00:03", ip: "192.168.3.10", mac: "AA:BB:CC:33:44:03" },
      ip: "192.168.3.10", mac: "AA:BB:CC:33:44:03",
      telemetry: null,
      events: [
        { time: ago(1), type: "Info", msg: "All 3 sensor nodes reporting — system healthy" },
        { time: ago(120), type: "Info", msg: "IP lease renewed — 192.168.3.10" },
      ]
    },
    {
      id: "GW-004", name: "Cellular Gateway Delta", role: "Gateway",
      type: "Cellular Gateway", connectivity: "Cellular",
      status: "Offline", healthScore: 12,
      model: "CGW-1000", make: "Quectel", firmware: "v1.8.3",
      serialNumber: "CGW-D4088-X", installedOn: "2024-09-14", lastSeen: ago(280),
      site: "Remote Station D", siteId: "SITE-003", assignedSolution: "Irrigation",
      battery: null, signal: -105,
      childDeviceIds: ["SN-009"],
      cellularDetails: { rssi: -105, network: "4G LTE", operator: "Airtel", simIccid: "8991101200003290", imei: "352651101234567", apn: "airtelgprs.com", signalBars: 1 },
      ip: "10.0.0.4", mac: "AA:BB:CC:44:55:04",
      telemetry: null,
      events: [
        { time: ago(280), type: "Error", msg: "Connection lost — cellular signal dropped below threshold" },
        { time: ago(300), type: "Warning", msg: "Signal strength critical: -105 dBm" },
        { time: ago(1440 * 2), type: "Info", msg: "SIM ICCID verified — data plan active" },
      ]
    },
  ],

  // ── Sensors ────────────────────────────────────────────────────────────────
  sensors: [
    {
      id: "SN-001", name: "Water Level Sensor 1", role: "Sensor",
      type: "Water Level", connectivity: "LoRa",
      status: "Online", healthScore: 94,
      model: "WLS-200", make: "IoTMATE", firmware: "v1.6.0",
      serialNumber: "WLS-001-X", installedOn: "2024-03-15", lastSeen: ago(2),
      site: "Industrial Zone A", siteId: "SITE-001", assignedSolution: "STP",
      battery: 82, signal: -71, gatewayId: "GW-001",
      loraDetails: { rssi: -71, snr: 7.2, sf: 10, bandwidth: "125kHz", codingRate: "4/5", packetsToday: 288, packetLoss: 0.3 },
      telemetry: { level: 4.25, unit: "m", flow: 12.4, turbidity: 2.1, ph: 7.2, temp: 28.4 },
      events: [
        { time: ago(2), type: "Info", msg: "Reading: Level 4.25m, Flow 12.4 m³/h" },
        { time: ago(120), type: "Info", msg: "Battery at 82% — expected 45 days remaining" },
      ]
    },
    {
      id: "SN-002", name: "Air Quality Monitor A", role: "Sensor",
      type: "AQM Sensor", connectivity: "LoRa",
      status: "Online", healthScore: 89,
      model: "AQS-300", make: "Sensirion", firmware: "v2.1.0",
      serialNumber: "AQS-002-X", installedOn: "2024-04-01", lastSeen: ago(3),
      site: "Industrial Zone A", siteId: "SITE-001", assignedSolution: "AQM",
      battery: 74, signal: -74, gatewayId: "GW-001",
      loraDetails: { rssi: -74, snr: 6.8, sf: 10, bandwidth: "125kHz", codingRate: "4/5", packetsToday: 312, packetLoss: 0.8 },
      telemetry: { pm25: 38.4, pm10: 62.1, co2: 924, tvoc: 0.38, temp: 24.8, humidity: 59, aqi: 87 },
      events: [
        { time: ago(3), type: "Info", msg: "AQI: 87 (Moderate) — PM2.5 38.4 µg/m³" },
        { time: ago(360), type: "Warning", msg: "CO2 briefly exceeded 1000 ppm threshold" },
      ]
    },
    {
      id: "SN-003", name: "Flow Meter Station 1", role: "Sensor",
      type: "Flow Meter", connectivity: "LoRa",
      status: "Warning", healthScore: 65,
      model: "FM-450", make: "Endress+Hauser", firmware: "v1.9.2",
      serialNumber: "FM-003-X", installedOn: "2024-03-20", lastSeen: ago(15),
      site: "Industrial Zone A", siteId: "SITE-001", assignedSolution: "Irrigation",
      battery: 41, signal: -88, gatewayId: "GW-001",
      loraDetails: { rssi: -88, snr: 2.4, sf: 11, bandwidth: "125kHz", codingRate: "4/5", packetsToday: 198, packetLoss: 8.2 },
      telemetry: { flow: 5.8, totalVolume: 2840.5, pressure: 2.1, temp: 26.1 },
      events: [
        { time: ago(15), type: "Warning", msg: "Packet loss 8.2% — signal degraded (RSSI -88 dBm)" },
        { time: ago(180), type: "Warning", msg: "Battery low (41%) — recommend replacement within 30 days" },
      ]
    },
    {
      id: "SN-004", name: "CO2 Room Sensor B1", role: "Sensor",
      type: "CO2 Sensor", connectivity: "LoRa",
      status: "Online", healthScore: 82,
      model: "CO2-100", make: "Sensirion", firmware: "v1.4.0",
      serialNumber: "CO2-004-X", installedOn: "2024-06-01", lastSeen: ago(5),
      site: "Office Block B", siteId: "SITE-002", assignedSolution: "AQM",
      battery: 68, signal: -84, gatewayId: "GW-002",
      loraDetails: { rssi: -84, snr: 2.9, sf: 11, bandwidth: "125kHz", codingRate: "4/5", packetsToday: 241, packetLoss: 5.1 },
      telemetry: { co2: 842, temp: 23.5, humidity: 55, tvoc: 0.22, aqi: 72 },
      events: [
        { time: ago(5), type: "Info", msg: "CO2: 842 ppm — within normal range" },
      ]
    },
    {
      id: "SN-005", name: "PM2.5 Outdoor Node B2", role: "Sensor",
      type: "AQM Sensor", connectivity: "LoRa",
      status: "Warning", healthScore: 58,
      model: "AQS-300", make: "Sensirion", firmware: "v2.0.5",
      serialNumber: "AQS-005-X", installedOn: "2024-06-05", lastSeen: ago(22),
      site: "Office Block B", siteId: "SITE-002", assignedSolution: "AQM",
      battery: 28, signal: -91, gatewayId: "GW-002",
      loraDetails: { rssi: -91, snr: 1.2, sf: 12, bandwidth: "125kHz", codingRate: "4/5", packetsToday: 102, packetLoss: 14.5 },
      telemetry: { pm25: 72.8, pm10: 138.2, aqi: 152, temp: 32.4, humidity: 68 },
      events: [
        { time: ago(22), type: "Warning", msg: "High PM2.5: 72.8 µg/m³ — AQI Unhealthy (152)" },
        { time: ago(30), type: "Warning", msg: "Critical battery level (28%) — immediate replacement needed" },
      ]
    },
    {
      id: "SN-006", name: "Temperature Sensor C1", role: "Sensor",
      type: "Temperature", connectivity: "WiFi",
      status: "Online", healthScore: 91,
      model: "TMP-50", make: "Bosch", firmware: "v1.2.0",
      serialNumber: "TMP-006-X", installedOn: "2024-07-10", lastSeen: ago(1),
      site: "Residential Complex C", siteId: "SITE-005", assignedSolution: "Facility",
      battery: null, signal: -52, gatewayId: "GW-003",
      wifiDetails: { rssi: -52, channel: 6, frequency: "2.4GHz", ssid: "IoTMATE-Infra", ip: "192.168.3.101", mac: "11:22:33:C1:00:06" },
      telemetry: { temp: 22.8, humidity: 54, pressure: 1013.2 },
      events: [
        { time: ago(1), type: "Info", msg: "Temp: 22.8°C, Humidity: 54% — comfort zone" },
      ]
    },
    {
      id: "SN-007", name: "Energy Meter C2", role: "Sensor",
      type: "Energy Meter", connectivity: "Ethernet",
      status: "Online", healthScore: 97,
      model: "EM-800", make: "Schneider Electric", firmware: "v3.0.4",
      serialNumber: "EM-007-X", installedOn: "2024-07-12", lastSeen: ago(0),
      site: "Residential Complex C", siteId: "SITE-005", assignedSolution: "Facility",
      battery: null, signal: null, gatewayId: "GW-003",
      ethernetDetails: { ip: "192.168.3.102", mac: "11:22:33:C2:00:07", speed: "100 Mbps", duplex: "Full" },
      telemetry: { voltage: 231.4, current: 18.6, power: 4.3, energy: 1248.5, pf: 0.96, freq: 50 },
      events: [
        { time: ago(0), type: "Info", msg: "Power: 4.3 kW, PF: 0.96 — normal load" },
      ]
    },
    {
      id: "SN-008", name: "Humidity Sensor C3", role: "Sensor",
      type: "Humidity", connectivity: "WiFi",
      status: "Error", healthScore: 23,
      model: "HUM-30", make: "Sensirion", firmware: "v1.1.0",
      serialNumber: "HUM-008-X", installedOn: "2024-08-01", lastSeen: ago(95),
      site: "Residential Complex C", siteId: "SITE-005", assignedSolution: "AQM",
      battery: null, signal: -97, gatewayId: "GW-003",
      wifiDetails: { rssi: -97, channel: 6, frequency: "2.4GHz", ssid: "IoTMATE-Infra", ip: "192.168.3.103", mac: "11:22:33:C3:00:08" },
      telemetry: { temp: null, humidity: null },
      events: [
        { time: ago(95), type: "Error", msg: "Sensor read failure — I2C bus error. Last valid reading 95 min ago." },
        { time: ago(98), type: "Error", msg: "Reconnection attempt failed (WiFi RSSI -97 dBm)" },
      ]
    },
    {
      id: "SN-009", name: "Remote Soil Sensor D1", role: "Sensor",
      type: "Soil Moisture", connectivity: "Cellular",
      status: "Offline", healthScore: 8,
      model: "SMS-100", make: "IoTMATE", firmware: "v1.3.0",
      serialNumber: "SMS-009-X", installedOn: "2024-09-15", lastSeen: ago(285),
      site: "Remote Station D", siteId: "SITE-003", assignedSolution: "Irrigation",
      battery: 14, signal: -108, gatewayId: "GW-004",
      cellularDetails: { rssi: -108, network: "4G LTE", operator: "Airtel", simIccid: "8991101200003291", imei: "352651101234568", apn: "airtelgprs.com", signalBars: 0 },
      telemetry: { moisture: null, temp: null },
      events: [
        { time: ago(285), type: "Error", msg: "Offline — last ping failed. Battery critical (14%)." },
        { time: ago(290), type: "Error", msg: "Cellular data session dropped — no reconnect" },
      ]
    },
    {
      id: "SN-010", name: "Modbus Flow Meter E1", role: "Sensor",
      type: "Flow Meter", connectivity: "Modbus",
      status: "Online", healthScore: 95,
      model: "FM-800M", make: "Yokogawa", firmware: "v4.1.0",
      serialNumber: "FM-010-X", installedOn: "2024-02-28", lastSeen: ago(0),
      site: "STP Plant E", siteId: "SITE-004", assignedSolution: "STP",
      battery: null, signal: null, gatewayId: null,
      modbusDetails: { slaveAddress: 3, protocol: "Modbus RTU", baudRate: 9600, parity: "None", stopBits: 1, registerMap: "FC03: 40001-40010" },
      telemetry: { flow: 18.2, totalVolume: 98420.5, pressure: 3.8, temp: 30.1 },
      events: [
        { time: ago(0), type: "Info", msg: "Flow: 18.2 m³/h — STP inlet normal" },
      ]
    },
    {
      id: "SN-011", name: "pH Sensor E2", role: "Sensor",
      type: "pH Sensor", connectivity: "Modbus",
      status: "Online", healthScore: 92,
      model: "PH-500M", make: "Hach", firmware: "v2.3.0",
      serialNumber: "PH-011-X", installedOn: "2024-02-28", lastSeen: ago(1),
      site: "STP Plant E", siteId: "SITE-004", assignedSolution: "STP",
      battery: null, signal: null, gatewayId: null,
      modbusDetails: { slaveAddress: 4, protocol: "Modbus RTU", baudRate: 9600, parity: "None", stopBits: 1, registerMap: "FC03: 40011-40020" },
      telemetry: { ph: 7.4, orp: 248, conductivity: 1420, dissolved_o2: 6.8, temp: 28.9 },
      events: [
        { time: ago(1), type: "Info", msg: "pH 7.4 — within CPCB outlet standard (6.5–9.0)" },
      ]
    },
    {
      id: "SN-012", name: "Bluetooth Asset Tag F1", role: "Sensor",
      type: "Asset Tag", connectivity: "Bluetooth",
      status: "Online", healthScore: 76,
      model: "BLE-100", make: "Nordic Semi", firmware: "v1.0.5",
      serialNumber: "BLE-012-X", installedOn: "2024-10-01", lastSeen: ago(4),
      site: "Office Block B", siteId: "SITE-002", assignedSolution: "Facility",
      battery: 63, signal: -72, gatewayId: "GW-003",
      bluetoothDetails: { rssi: -72, uuid: "550e8400-e29b-41d4-a716-446655440012", protocol: "BLE 5.0", txPower: 4 },
      telemetry: { location: "Conference Room B", temp: 23.1 },
      events: [
        { time: ago(4), type: "Info", msg: "Asset located: Conference Room B, Level 1" },
      ]
    },
  ],

  // ── Controllers ────────────────────────────────────────────────────────────
  controllers: [
    {
      id: "CT-001", name: "Irrigation Controller 1", role: "Controller",
      type: "Irrigation Controller", connectivity: "LoRa",
      status: "Online", healthScore: 93,
      model: "ICT-300", make: "IoTMATE", firmware: "v2.2.0",
      serialNumber: "ICT-001-X", installedOn: "2024-03-18", lastSeen: ago(2),
      site: "Industrial Zone A", siteId: "SITE-001", assignedSolution: "Irrigation",
      battery: null, signal: -69, gatewayId: "GW-001",
      loraDetails: { rssi: -69, snr: 8.8, sf: 10, bandwidth: "125kHz", codingRate: "4/5", packetsToday: 186, packetLoss: 0.5 },
      telemetry: { zones: 4, activeZone: "Zone 2", flow: 8.4, pressure: 2.8, runtime: 42 },
      controls: { valves: ["Zone1:Closed","Zone2:Open","Zone3:Closed","Zone4:Closed"], mode: "Auto", schedule: "06:00 & 18:00" },
      events: [
        { time: ago(2), type: "Info", msg: "Zone 2 irrigation active — scheduled watering cycle" },
        { time: ago(62), type: "Info", msg: "Zone 1 completed — 42 min runtime" },
      ]
    },
    {
      id: "CT-002", name: "HVAC Controller B1", role: "Controller",
      type: "HVAC Controller", connectivity: "WiFi",
      status: "Online", healthScore: 87,
      model: "HVC-500", make: "Siemens", firmware: "v3.4.1",
      serialNumber: "HVC-002-X", installedOn: "2024-07-15", lastSeen: ago(0),
      site: "Office Block B", siteId: "SITE-002", assignedSolution: "Facility",
      battery: null, signal: -58, gatewayId: "GW-003",
      wifiDetails: { rssi: -58, channel: 11, frequency: "5GHz", ssid: "IoTMATE-Infra", ip: "192.168.3.201", mac: "11:22:33:B1:00:02" },
      telemetry: { setpoint: 24.0, roomTemp: 24.3, mode: "Cooling", fanSpeed: "Medium", damper: 65 },
      controls: { mode: "Auto", setpoint: 24.0, fanSpeed: "Medium", schedule: "Mon-Fri 08:00-20:00" },
      events: [
        { time: ago(0), type: "Info", msg: "HVAC cooling active — room 24.3°C vs setpoint 24.0°C" },
        { time: ago(480), type: "Info", msg: "Schedule activated at 08:00 — switched from Night mode" },
      ]
    },
    {
      id: "CT-003", name: "Pump Controller E1", role: "Controller",
      type: "Pump Controller", connectivity: "Ethernet",
      status: "Warning", healthScore: 68,
      model: "PCT-200", make: "ABB", firmware: "v2.0.0",
      serialNumber: "PCT-003-X", installedOn: "2024-03-01", lastSeen: ago(12),
      site: "STP Plant E", siteId: "SITE-004", assignedSolution: "STP",
      battery: null, signal: null, gatewayId: null,
      ethernetDetails: { ip: "192.168.5.201", mac: "AA:BB:CC:E1:00:03", speed: "100 Mbps", duplex: "Full" },
      telemetry: { pump1: "Running", pump2: "Standby", flow: 18.2, pressure: 3.8, temp: 45.2, vibration: 3.8 },
      controls: { mode: "Auto", pump1: "Running", pump2: "Standby", flowSetpoint: 20.0 },
      events: [
        { time: ago(12), type: "Warning", msg: "Motor temperature high: 45.2°C (threshold: 45°C)" },
        { time: ago(120), type: "Warning", msg: "Vibration level elevated: 3.8 mm/s (normal <3.0)" },
      ]
    },
    {
      id: "CT-004", name: "Motor Drive E2", role: "Controller",
      type: "Motor Drive", connectivity: "Modbus",
      status: "Online", healthScore: 94,
      model: "VFD-750", make: "Schneider Electric", firmware: "v5.1.0",
      serialNumber: "VFD-004-X", installedOn: "2024-02-28", lastSeen: ago(0),
      site: "STP Plant E", siteId: "SITE-004", assignedSolution: "STP",
      battery: null, signal: null, gatewayId: null,
      modbusDetails: { slaveAddress: 5, protocol: "Modbus RTU", baudRate: 19200, parity: "None", stopBits: 1, registerMap: "FC03: 40101-40120" },
      telemetry: { speed: 1450, torque: 68.4, current: 12.8, voltage: 415, power: 7.3, temp: 38.5 },
      controls: { mode: "Remote", speedSetpoint: 1450, direction: "Forward" },
      events: [
        { time: ago(0), type: "Info", msg: "VFD running at 1450 RPM — aeration blower normal" },
      ]
    },
  ],

  // ── Alerts ─────────────────────────────────────────────────────────────────
  alerts: [
    { id: "AL-001", deviceId: "SN-005", deviceName: "PM2.5 Outdoor Node B2", severity: "Critical", type: "Battery", msg: "Battery critically low at 28% — device may go offline within 24h", time: ago(30), ack: false },
    { id: "AL-002", deviceId: "GW-004", deviceName: "Cellular Gateway Delta", severity: "Critical", type: "Connectivity", msg: "Gateway offline for 4h 40min — all child devices unreachable", time: ago(280), ack: false },
    { id: "AL-003", deviceId: "SN-008", deviceName: "Humidity Sensor C3", severity: "Critical", type: "Device Error", msg: "I2C bus error — sensor not responding. Manual inspection required", time: ago(95), ack: false },
    { id: "AL-004", deviceId: "CT-003", deviceName: "Pump Controller E1", severity: "Warning", type: "Temperature", msg: "Motor temp exceeded 45°C threshold — check cooling ventilation", time: ago(12), ack: false },
    { id: "AL-005", deviceId: "SN-003", deviceName: "Flow Meter Station 1", severity: "Warning", type: "Signal", msg: "High packet loss (8.2%) — RSSI -88 dBm. Check antenna alignment", time: ago(15), ack: true },
    { id: "AL-006", deviceId: "GW-002", deviceName: "LoRa Gateway Beta", severity: "Warning", type: "Connectivity", msg: "Backhaul packet loss 6.8% — verify ISP connection quality", time: ago(8), ack: false },
  ],

  // ── Event Log ──────────────────────────────────────────────────────────────
  events: [
    { id: "EV-001", deviceId: "SN-008", deviceName: "Humidity Sensor C3", type: "Error", msg: "I2C bus error — sensor read failed", time: ago(95), user: "System" },
    { id: "EV-002", deviceId: "GW-004", deviceName: "Cellular Gateway Delta", type: "Error", msg: "Cellular connection lost — RSSI -105 dBm below minimum", time: ago(280), user: "System" },
    { id: "EV-003", deviceId: "CT-003", deviceName: "Pump Controller E1", type: "Warning", msg: "Motor temperature alarm: 45.2°C", time: ago(12), user: "System" },
    { id: "EV-004", deviceId: "SN-003", deviceName: "Flow Meter Station 1", type: "Warning", msg: "Packet loss exceeded 8% threshold", time: ago(15), user: "System" },
    { id: "EV-005", deviceId: "GW-001", deviceName: "LoRa Gateway Alpha", type: "Info", msg: "Firmware check passed — running latest v2.4.1", time: ago(60), user: "System" },
    { id: "EV-006", deviceId: "CT-001", deviceName: "Irrigation Controller 1", type: "Info", msg: "Zone 2 irrigation cycle started", time: ago(2), user: "Schedule" },
    { id: "EV-007", deviceId: "SN-001", deviceName: "Water Level Sensor 1", type: "Info", msg: "Level reading: 4.25m — normal range", time: ago(2), user: "System" },
    { id: "EV-008", deviceId: "SN-005", deviceName: "PM2.5 Outdoor Node B2", type: "Warning", msg: "Battery low alert: 28%", time: ago(30), user: "System" },
    { id: "EV-009", deviceId: "CT-002", deviceName: "HVAC Controller B1", type: "Info", msg: "Morning schedule activated — cooling mode engaged", time: ago(480), user: "Schedule" },
    { id: "EV-010", deviceId: "SN-007", deviceName: "Energy Meter C2", type: "Info", msg: "Peak load detected: 4.3 kW at 14:30", time: ago(30), user: "System" },
    { id: "EV-011", deviceId: "GW-003", deviceName: "WiFi Gateway Gamma", type: "Info", msg: "DHCP lease renewed — IP 192.168.3.10", time: ago(120), user: "System" },
    { id: "EV-012", deviceId: "SN-009", deviceName: "Remote Soil Sensor D1", type: "Error", msg: "Offline — last ping failed (cellular signal lost)", time: ago(285), user: "System" },
    { id: "EV-013", deviceId: "GW-002", deviceName: "LoRa Gateway Beta", type: "Warning", msg: "Backhaul packet loss elevated to 6.8%", time: ago(8), user: "System" },
    { id: "EV-014", deviceId: "SN-011", deviceName: "pH Sensor E2", type: "Info", msg: "pH 7.4 within CPCB limits — outlet compliant", time: ago(1), user: "System" },
    { id: "EV-015", deviceId: "CT-004", deviceName: "Motor Drive E2", type: "Info", msg: "VFD speed setpoint confirmed: 1450 RPM", time: ago(0), user: "System" },
  ],

  // ── Reports ────────────────────────────────────────────────────────────────
  reports: [
    { id: "RP-001", name: "Device Health Summary", format: "PDF", lastGenerated: "2026-02-27 06:00", schedule: "Daily 06:00", size: "280 KB" },
    { id: "RP-002", name: "Connectivity Diagnostics Report", format: "Excel", lastGenerated: "2026-02-27 08:00", schedule: "Daily 08:00", size: "145 KB" },
    { id: "RP-003", name: "Alert & Event Log Export", format: "CSV", lastGenerated: "2026-02-28 00:00", schedule: "Weekly Monday", size: "92 KB" },
    { id: "RP-004", name: "Firmware Audit Report", format: "PDF", lastGenerated: "2026-02-01 00:00", schedule: "Monthly 1st", size: "64 KB" },
    { id: "RP-005", name: "Battery Status Report", format: "PDF", lastGenerated: "2026-02-28 06:00", schedule: "Daily 06:00", size: "38 KB" },
  ],
};

// ── Flat list of all devices ─────────────────────────────────────────────────
export const allDevices = [
  ...deviceDummyData.gateways,
  ...deviceDummyData.sensors,
  ...deviceDummyData.controllers,
];
